
export const currency = (value: number|undefined, symbol: string = '€') => value ? value.toFixed(2) + symbol : '0 ' + symbol

export const currencyValue = (value: number) => value ? Math.round(value * 100) / 100 : 0
